// src/pages/HR/reports/SalaryCompensation.js
import React, { useEffect, useMemo, useState } from "react";
import HRCampusSelector from "../../../components/HRCampusSelector";

function lsKey(campus) {
  return `employees_${String(campus || "gen").toLowerCase()}`;
}
function loadLocalEmployees(campus) {
  try {
    const raw = localStorage.getItem(lsKey(campus));
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}
function exportCSV(filename, rows) {
  const header = ["Employee","Position","Department","Monthly Salary","Allowance","Overtime Rate","Campus"];
  const body = rows.map(r => [r.name || "", r.position || "", r.department || "", r.salary || "", r.allowance || "", r.overtimeRate || "", r.campus || ""]);
  const csv = [header, ...body].map(r => r.map(x => `"${String(x).replace(/"/g,'""')}"`).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a"); a.href = url; a.download = filename; a.click(); URL.revokeObjectURL(url);
}

export default function SalaryCompensation() {
  const [campus, setCampus] = useState(() => localStorage.getItem("hr_reports_campus") || "bulacan");
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => { setRows(loadLocalEmployees(campus)); }, [campus]);
  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return rows;
    return rows.filter(r => (r.name || "").toLowerCase().includes(s) || (r.position || "").toLowerCase().includes(s) || (r.department || "").toLowerCase().includes(s));
  }, [rows, q]);

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Salary & Compensation</h3>
        <div className="d-flex align-items-center gap-2 print-hide">
          <HRCampusSelector selectedCampus={campus} onChange={setCampus} />
          <input className="form-control" style={{ width: 240 }} placeholder="Search employee/position" value={q} onChange={e => setQ(e.target.value)} />
          <button className="btn btn-outline-secondary" onClick={() => window.print()}>Print</button>
          <button className="btn btn-primary" onClick={() => exportCSV(`salary-compensation-${campus}.csv`, filtered)}>Export CSV</button>
        </div>
      </div>
      <p className="text-muted">Current salary structure with allowances and overtime rates.</p>
      <div className="table-responsive">
        <table className="table table-striped table-bordered">
          <thead className="table-light">
            <tr>
              <th>Employee</th>
              <th>Position</th>
              <th>Department</th>
              <th>Monthly Salary</th>
              <th>Allowance</th>
              <th>Overtime Rate</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan="6" className="text-center text-muted">No records</td></tr>
            ) : filtered.map((r, i) => (
              <tr key={i}>
                <td>{r.name || ""}</td>
                <td>{r.position || ""}</td>
                <td>{r.department || ""}</td>
                <td>₱{Number(r.salary || 0).toLocaleString()}</td>
                <td>₱{Number(r.allowance || 0).toLocaleString()}</td>
                <td>₱{Number(r.overtimeRate || 0).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
